import type { CoordinateSet } from "@/map/types/map";

/**
 * Flatten the GPS trail points out of the coordinate sets MapView receives.
 * Only sets tagged `markerType: 'gps'` contribute — alert/machine/location
 * sets are ignored. The result feeds the Google heatmap layer.
 */
export const collectHeatmapPoints = (
  sets: CoordinateSet[],
): { lat: number; lng: number }[] => {
  const points: { lat: number; lng: number }[] = [];
  for (const set of sets) {
    if (set.markerType !== "gps") continue;
    for (const point of set.path) {
      points.push({ lat: point.lat, lng: point.lng });
    }
  }
  return points;
};
